<div [formGroup]="reimbursementForm">
    <div>
        <mat-form-field class="mb-3">
            <mat-label>Transaction token</mat-label>
            <input matInput type="text" formControlName="token">
        </mat-form-field>  
    </div>
    <div>
        <mat-form-field class="mb-3">
            <mat-label>Amount to reimburse</mat-label>
            <input matInput type="text" formControlName="amount">
            <mat-error *ngIf="reimbursementForm.get('amount').hasError('invalidFormat')"
            >Only numbers, commas, and dots are allowed.
            </mat-error>
        </mat-form-field>
    </div>
  </div>
  <div>
    <button mat-raised-button [disabled]="loading" (click)="submitForm()" class="button">
      <span *ngIf="!loading">Make a reimbursement</span>
      <mat-spinner [diameter]="36" *ngIf="loading"></mat-spinner>
    </button>
  </div>